import React from 'react';
import Modal from '@material-ui/core/Modal';
import style from './OverwriteModal.module.css';
import TextButton from '../../../../atomic/buttons/textButton/TextButton';
import PropTypes from 'prop-types';

function OverwriteModal({ configName, open, handleClose, updateConfig }) {
  return (
    <Modal open={open} onClose={handleClose} onBackdropClick={handleClose}>
      <div className={style.modalContainer}>
        <h6>
          A template called <span className={style.name}>{configName}</span> already exists.<br/> Would you
          like to overwrite it?
        </h6>
        <div className={style.buttons}>
          <TextButton
            fontSize="medium"
            width="100px"
            clickHandler={updateConfig}
            color="white"
            backgroundColor="red"
          >
            Overwrite
          </TextButton>
          <TextButton
            fontSize="medium"
            width="100px"
            clickHandler={handleClose}
            color="white"
            backgroundColor="blue"
          >
            Cancel
          </TextButton>
        </div>
      </div>
    </Modal>
  );
}
OverwriteModal.propTypes = {
  configName: PropTypes.string.isRequired,
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  updateConfig: PropTypes.func.isRequired,
};

export default OverwriteModal;
